var map = {
	"./base.js": "9dOz",
	"./date.js": "6SDH",
	"./go.js": "/167"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "aQCI";


//////////////////
// WEBPACK FOOTER
// ./src/global/modules [\w-]+\.js$
// module id = aQCI
// module chunks = 227